import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class HardwareUpgradeAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenUserAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getHardwareUpgradeTableList', {
            url: '/admin/upgrade/index',
            name: 'list',
            label: '列表'
        }],
        ['addHardwareUpgrade', {
            url: '/admin/upgrade/add',
            name: 'add-headware-updrade',
            label: '添加升级版本包'
        }],
    ])


    // // 设备列表
    public getHardwareUpgradeTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getHardwareUpgradeTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 添加升级版本包
    public addHardwareUpgrade(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
  
        const url = apiUrls.get('addHardwareUpgrade').url
  
        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
      }
  


}